import { useEffect, useState } from 'react';
import type { AnalyticsRange, AnalyticsSummary } from '@shared/analytics';

async function fetchSummary(range: AnalyticsRange, signal: AbortSignal) {
  const response = await fetch('/api/analytics/summary?range=' + range, {
    headers: { 'x-admin-token': sessionStorage.getItem('admin_token') || '' },
    signal,
  });
  if (!response.ok) throw new Error('运营数据暂时无法读取，请重试');
  return (await response.json()) as AnalyticsSummary;
}

export function useAnalyticsData() {
  const [range, setRange] = useState<AnalyticsRange>('7d');
  const [revision, setRevision] = useState(0);
  const [data, setData] = useState<AnalyticsSummary | null>(null);
  const [error, setError] = useState('');
  const [busy, setBusy] = useState(true);
  useEffect(() => {
    // 切换范围时中止旧请求，避免慢请求覆盖新结果。
    const controller = new AbortController();
    setBusy(true);
    setError('');
    fetchSummary(range, controller.signal)
      .then((summary) => {
        if (!controller.signal.aborted) setData(summary);
      })
      .catch((e: unknown) => {
        if (controller.signal.aborted) return;
        setData(null);
        setError(
          e instanceof Error ? e.message : '运营数据暂时无法读取，请重试',
        );
      })
      .finally(() => {
        if (!controller.signal.aborted) setBusy(false);
      });
    return () => controller.abort();
  }, [range, revision]);
  return {
    range,
    data: data?.range === range ? data : null,
    error,
    busy,
    setRange,
    refresh: () => setRevision((n) => n + 1),
  };
}
